module.exports = __webpack_public_path__ + "img/des_solutio_s.8fc10cc7.png";